var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5617 14.5312H18.3958C20.2983 14.5312 21.7969 12.9215 21.7969 11.0112V4.496C21.7969 2.64162 20.2425 1.24849 18.3855 0.93912C17.2104 0.743417 15.9961 0.654354 14.8261 0.659979C13.6565 0.66537 12.5733 0.764979 11.5905 0.93912C8.69483 1.45029 8.20311 2.52139 8.20311 4.496V7.03123H15V7.96873H5.57249C3.58405 7.96873 1.84264 9.16592 1.29819 11.4401C0.669832 14.0463 0.641942 15.6398 1.29819 18.3612C1.78452 20.3866 2.94585 21.7969 4.93452 21.7969H7.26561V18.7387C7.26561 16.4801 9.24093 14.5312 11.5617 14.5312ZM11.1309 5.36482C10.4217 5.36482 9.84702 4.78381 9.84702 4.06521C9.84702 3.34357 10.4215 2.75717 11.1309 2.75717C11.8376 2.75717 12.4151 3.34357 12.4151 4.06521C12.4148 4.78381 11.8373 5.36482 11.1309 5.36482ZM28.6596 11.4401C28.1679 9.46006 27.2292 7.96873 25.238 7.96873H22.7344V11.0112C22.7344 13.3666 20.6733 15.2344 18.3958 15.2344H11.5617C9.68952 15.2344 8.20311 16.9514 8.20311 18.8264V25.342C8.20311 27.1959 9.78397 28.2867 11.5926 28.8187C13.7587 29.4555 15.81 29.5706 18.4015 28.8187C20.1239 28.3197 21.7969 27.3162 21.7969 25.342V22.7344H15V21.7969H25.238C27.2264 21.7969 27.9677 20.4431 28.6596 18.3609C29.3737 16.2176 29.343 14.1893 28.6596 11.4401ZM18.8264 24.4727C19.5358 24.4727 20.1105 25.0537 20.1105 25.7728C20.1105 26.4937 19.5361 27.0804 18.8264 27.0804C18.1198 27.0804 17.5425 26.494 17.5425 25.7728C17.5425 25.0537 18.1198 24.4727 18.8264 24.4727Z",
    fill: "#606060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPy);
export default __webpack_public_path__ + "static/media/py.e9ac6be4495a03d8bc4eaec5cee86859.svg";
export { ForwardRef as ReactComponent };